export interface CalendarClosure {
  start: string // YYYY-MM-DD, first closed day
  end: string // YYYY-MM-DD, last closed day (inclusive)
  label: string
}

// Days the studio is closed. Add a new entry here to show it on the Classes
// calendar and in the PDF export.
export const CALENDAR_CLOSURES: CalendarClosure[] = [
  { start: '2026-11-26', end: '2026-11-26', label: 'Thanksgiving' },
  { start: '2026-11-27', end: '2026-11-27', label: 'Day After Thanksgiving' },
  { start: '2026-12-25', end: '2027-01-01', label: 'Holiday Break' }
]

export const getClosureForDate = (date: Date): CalendarClosure | undefined => {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const dateKey = `${date.getFullYear()}-${month}-${day}`

  return CALENDAR_CLOSURES.find(closure => dateKey >= closure.start && dateKey <= closure.end)
}
